import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { LightningIcon, InfoIcon } from "@phosphor-icons/react";
import CustomTag from "../../../ui/CustomTag";
import { TIMEZONE } from "../utils/trackingUtils";

const TimeTableAutomationRow = ({ automation, projects, tasks, activeDay, hasEntries }) => {
    const task = tasks.find((t) => t.id === automation.model.taskId);
    const project = projects.find((p) => p.id === task?.section?.projectId);

    return (
        <tr className="automation-generated-line">
            <td style={{ display: hasEntries ? "table-cell" : "none" }}></td>
            <td className="entry-line-date">
                <CustomTag value={activeDay.tz(TIMEZONE).format("DD/MM/YYYY")} />
            </td>
            <td className="entry-line-project">
                <span>{project?.name || ""}</span>
            </td>
            <td className="entry-line-task">
                <CustomTag value={task?.name || ""} />
            </td>
            <td className="entry-line-comments">
                <span className="comments">{automation.model.comments}</span>
            </td>
            <td className="entry-line-duration">
                <CustomTag value={automation.model.duration + " h"} />
            </td>
            <td className="entry-line-actions">
                <IconButton aria-label="automation" size="small">
                    <LightningIcon size={18} color="#3b61e1" weight="fill" />
                </IconButton>
                <Tooltip placement="left" title="Cette tâche sera créée automatiquement">
                    <IconButton aria-label="info" size="small">
                        <InfoIcon size={18} color="#7a7a7a" weight="bold" />
                    </IconButton>
                </Tooltip>
            </td>
        </tr>
    );
};

export default React.memo(TimeTableAutomationRow);
